import * as c3 from 'c3';
import * as _ from 'lodash';

import '../../../node_modules/c3/c3.css';

class DataPoint {
  estimate: string;
  probability: number;

  constructor(estimate: string, probability: number) {
    this.estimate = estimate;
    this.probability = probability;
  }
};

let ChartRenderer = {
  renderBarChart: function(
    sorted: DataPoint[],
    divId: string,
    width: number,
    height: number,
    columnLabels: string[],
    xAxisTitle?: string
  ) {
    const xColumnLabel = xAxisTitle ? xAxisTitle : 'data1';

    const xColumn = [xColumnLabel].concat(sorted.map(d => d.estimate));
    const yColumn1Label = columnLabels[0];
    const yColumn2Label = columnLabels[1];

    let yColumn1: any[] = [yColumn1Label];
    yColumn1 = yColumn1.concat(sorted.map(d => d.probability));

    let yColumn2: any[] = [yColumn2Label];

    // cumulative probability
    const cumulativeProbabilities = this.calculateCumulativeProbability(sorted);
    yColumn2 = yColumn2.concat(cumulativeProbabilities);

    // note: to use categorized x-values https://c3js.org/samples/categorized.html
    const xs = columnLabels.reduce((acc, label) => { acc[label] = xColumnLabel; return acc; }, {});
    const axes = columnLabels.reduce((acc, label) => { acc[label] = 'y'; return acc; }, {});
    const types = {};
    types[columnLabels[0]] = 'bar';
    types[columnLabels[1]] = 'spline';
    c3.generate({
      bindto: '#' + divId,
      size: {
        height: 500
      },
      data: {
        xs: xs,
        columns: [
          xColumn,
          yColumn1,
          yColumn2
        ],
        axes: axes,
        types: types
      },
      axis: {
        y: {
          label: {
            text: '%',
            position: 'outer-middle'
          }
        }
      }
    });
  },

  calculateCumulativeProbability: function(points: DataPoint[]) {
    return _.reduce(points, (acc: number[], d) => {
      const last = _.last(acc);

      return acc.concat((last ? last : 0.0) + d.probability);
    }, []);
  }
};

export default ChartRenderer;


// WEBPACK FOOTER //
// ./src/services/chart/ChartRenderer.ts